import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DatePicker } from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import CoreFilter from "./CoreFilter";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import IconButton from "@material-ui/core/IconButton";
import ListItemText from "@material-ui/core/ListItemText";
import KpsListItem from "../../core-elements/KpsListItem";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import Table from "@material-ui/core/Table";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import Icon from "@mdi/react";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { taxServiceClient } from "../../AxiosClient";
import { connect } from "react-redux";
import { Badge } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

const styles = (theme) => ({
  container: {},
  gridContainer: {
    // alignItems: "center",
    flexGrow: 1,
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  userPickerFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  showClearTitle: {
    visibility: "visible",
  },
  hideClearTitle: {
    visibility: "hidden",
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangular: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
export class FilterSearchHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultFilters: [
        "status",
        "searchText",
        "searchedBy",
        // "createdStart",
        // "createdEnd",
      ],
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,

      searchedBy: null,
      searchText: (this.props.filter && this.props.filter.searchText) ? this.props.filter.searchText : "",
    };
  }
  componentDidMount() {
    if (
      this.props.filter.searchedBy &&
      this.props.filter.searchedBy.length > 0
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.searchedBy })
        .then((res) => {
          this.setState({ searchedBy: res.data });
        });
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if ((!this.props.filter.hasOwnProperty("searchText") || this.props.filter.searchText === null) && 
        _prevProps.filter.hasOwnProperty("searchText") && 
        this.state.searchText !== ""){
          this.setState({searchText: ""})
    }
    if (
      !areObjectsEqual(
        this.props.filter.searchedBy,
        _prevProps.filter.searchedBy
      )
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.searchedBy })
        .then((res) => {
          this.setState({ searchedBy: res.data });
        });
    }
  }
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.isMobile && this.props.menuDialog
      ? this.setState((prev) => ({
          menuCollapseOpened: !prev.menuCollapseOpened,
        }))
      : this.setState((prev) => ({ opened: !prev.opened }));
    //this.setState((prev) => ({ opened: !prev.opened }));
  };
  onSearchedByUpdate = (newUsers) => {
    let event = {};
    event.target = {};
    event.target.name = "searchedBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
  };
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    this.props.asPopper &&
      (filterObj.sort = (
        <>
          <FormControl className={classes.selectMargin}>
            <InputLabel shrink htmlFor="sort-type">
              <Trans i18nKey="global_sort_by" />
            </InputLabel>
            <Select
              value={this.props.filter.sort}
              onChange={this.props.handleSortChange}
              inputProps={{
                name: "sort",
                id: "sort",
              }}
            >
              <MenuItem value="attached">
                <Trans i18nKey="settings_searchhistory_attached_documents" />
              </MenuItem>
              <MenuItem value="views">
                <Trans i18nKey="settings_searchhistory_documents_viewed" />
              </MenuItem>
              <MenuItem value="searches">
                <Trans i18nKey="settings_searchhistory_number_of_searches" />
              </MenuItem>
              <MenuItem value="searchText">
                <Trans i18nKey="settings_searchhistory_search_string" />
              </MenuItem>
              <MenuItem value="lastSearchedDate">
                <Trans i18nKey="settings_searchhistory_last_searched" />
              </MenuItem>
            </Select>
          </FormControl>
          <Button onClick={this.props.toggleSortDirection}>
            {this.props.filter.sortDirection === "ASC" ? (
              <>
                <ArrowUpwardIcon />
                <Trans i18nKey="global_ascending" />
              </>
            ) : (
              <>
                <ArrowDownwardIcon />
                <Trans i18nKey="global_descending" />
              </>
            )}
          </Button>
        </>
      ));

    filterObj.searchText = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("searchText") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TextField
          id="searchText"
          label={t("filter_searches_search_text")}
          // className={classes.textField}
          // value={
          //   this.props.filter.searchText ? this.props.filter.searchText : ""
          // }
          // onChange={this.props.handleTextFieldChange("searchText")}
          name="searchText"
          value={this.state.searchText ? this.state.searchText : ""}
          InputProps={{
            endAdornment: (
              <IconButton
                size={"small"}
                className={this.state.searchText !== "" ? classes.showClearTitle : classes.hideClearTitle}
                onClick={() => { this.setState({ searchText: "" }, () => {this.props.handleTextFieldChangeFromState("searchText")("")}) }}
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
          // onChange={(e) =>
          //   this.setState(
          //     { searchText: e.target.value },
          //     this.props.handleTextFieldChange("searchText")(e)
          //     //this.props.handleChange(e)
          //   )
          // }
          onChange={(e) =>
            this.setState(
              { searchText: e.target.value }
            )
          }
          onKeyUp={(e) => {
              this.state.titleTimeout !== null && clearTimeout(this.state.titleTimeout)
              let timeOut = setTimeout(() => {
                this.props.handleTextFieldChangeFromState("searchText")(this.state.searchText)
              },
              350
            )
            this.setState({titleTimeout : timeOut})
          }}
          margin="normal"
        />
      </FormControl>
    );
    filterObj.status = (
      <FormControl className={classes.selectMargin}>
        <InputLabel shrink htmlFor="status">
          <Trans i18nKey="global_resolve_past_tense" />
        </InputLabel>
        <Select
          value={this.props.filter.status ? this.props.filter.status : "ALL"}
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "status",
            id: "status",
          }}
        >
          <MenuItem value="ALL">
            <Trans i18nKey="filter_discussions_all" />
          </MenuItem>
          <MenuItem value="LINKS_ONLY">
            <Trans i18nKey="filter_searches_attached_only" />
          </MenuItem>
          <MenuItem value="VIEWS_ONLY">
            <Trans i18nKey="filter_searches_views_only" />
          </MenuItem>
          <MenuItem value="NO_VIEWS_NO_LINKS">
            <Trans i18nKey="filter_searches_no_views_or_links" />
          </MenuItem>
        </Select>
      </FormControl>
    );
    filterObj.searchedBy = (
      <>
        {this.props.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
          (this.props.currentUser.userPermits.roles.teamLeader ||
            this.props.currentUser.userPermits.roles.systemManager) && (
            <FormControl className={classes.userPickerFormControl}>
              <UserTeamPicker
                usersOnly={true}
                onTeamUsersUpdate={this.onSearchedByUpdate}
                onUsersUpdate={this.onSearchedByUpdate}
                userHeaderKey=""
                userTeamHeaderKey="create_message_users_team_header"
                asChips
                loadUsers={this.state.searchedBy}
                hideNoUsersMessage={true}
              />
            </FormControl>
          )}
      </>
    );
    filterObj.createdStart = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdStart
              ? moment(this.props.filter.createdStart)
              : null
          }
          onChange={this.props.handleDateChange("createdStart")}
        />
      </FormControl>
    );
    filterObj.createdEnd = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdEnd
              ? moment(this.props.filter.createdEnd)
              : null
          }
          onChange={this.props.handleDateChange("createdEnd")}
        />
      </FormControl>
    );
    const activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map(
              (filter, idx) =>
                filterObj.hasOwnProperty(filter) &&
                this.state.defaultFilters.indexOf(filter) < 0 && (
                  <Grid
                    item
                    xs={
                      filter === "searchedBy" ||
                      filter === "status"
                        ? 12
                        : 6
                    }
                    sm={
                      filter === "searchedBy" ||
                      filter === "status"
                        ? 6
                        : 3
                    }
                    lg={
                      filter === "searchedBy" ||
                      filter === "status"
                        ? 6 
                        : 2
                    }
                  >
                    {filterObj[filter]}
                  </Grid>
                )
            )}
      </>
    );
    const inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(filterObj).map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 && (
                <Grid
                  item
                  xs={
                    filter === "searchedBy" ||
                    filter === "status"
                      ? 12
                      : 6
                  }
                  sm={
                    filter === "searchedBy" ||
                    filter === "status"
                      ? 6
                      : 3
                  }
                  lg={
                    filter === "searchedBy" ||
                    filter === "status"
                      ? 6 
                      : 2
                  }
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
      </>
    );
    let defaultFilters = (
      <>
        <>
          {this.state.defaultFilters.map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) && (
                <Grid
                  item
                  xs={
                    filter === "searchedBy" ||
                    filter === "status"
                      ? 12
                      : 6
                  }
                  sm={
                    filter === "searchedBy" ||
                    filter === "status" 
                      ? 6
                      : 3
                  }
                  lg={
                    filter === "searchedBy" ||
                    filter === "status"
                      ? 6 
                      : 2
                  }
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
        </>
      </>
    );
    return (
      <>
        {this.props.asPopper ? (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className={classes.filterCtr}>
              <div>
                {this.props.showReset && (
                  <Button
                    className={classes.resetButton}
                    onClick={this.props.resetToDefaultFilters}
                  >
                    <Trans i18nKey="filters_reset_to_default" />
                  </Button>
                )}
                <ExpansionPanel
                  expanded={expanded === "sort"}
                  onChange={this.props.handleExpansionPanelChange("sort")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_documents_sort_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div className={classes.sortByContainer}>
                      {/* <Typography className={classes.sortByLabel}>
                        <Trans i18nKey="global_sort" />
                      </Typography> */}
                      {filterObj.sort}
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "basic"}
                  onChange={this.props.handleExpansionPanelChange("basic")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_basic" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_searches_basic_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.searchText}
                    {filterObj.status}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                {this.props.objectClass ===
                  "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
                  (this.props.currentUser.userPermits.roles.teamLeader ||
                    this.props.currentUser.userPermits.roles.systemManager) && (
                    <ExpansionPanel
                      expanded={expanded === "users"}
                      onChange={this.props.handleExpansionPanelChange("users")}
                    >
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={classes.heading}>
                          <Trans i18nKey="global_user_plural" />
                        </Typography>
                        <Typography className={classes.secondaryHeading}>
                          <Trans i18nKey="filter_searches_users_secondary_heading" />
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        {filterObj.searchedBy}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  )}
                <ExpansionPanel
                  expanded={expanded === "dates"}
                  onChange={this.props.handleExpansionPanelChange("dates")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort_dates" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_searches_dates_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div className={classes.datesContainer}>
                      {filterObj.createdStart}
                      {filterObj.createdEnd}
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
            </div>
          </MuiPickersUtilsProvider>
        ) : (
          <div style={{ width: "100%", flexGrow: 1 }}>
            <ListItem
              className={classes.listItem}
              style={{
                paddingLeft: this.props.preText ? 0 : 10,
                borderRight: this.props.selected
                  ? `2px solid ${this.props.theme.palette.primary.main}`
                  : "",
              }}
              ContainerComponent="div"
              disableGutters={true}
              dense={true}
              selected={false}
            >
              {this.props.preText}
              <ListItemText
                primary={
                  <>
                    <div className={classes.filterWrapper}>
                      <span>
                        <IconButton
                          onClick={this.props.resetToDefaultFilters}
                          size="large"
                          color={
                            this.props.showReset === true
                              ? "secondary"
                              : "default"
                          }
                          disabled={this.props.showReset === false}
                        >
                          <Icon
                            path={
                              this.props.showReset === true
                                ? mdiFilterVariantRemove
                                : mdiFilterVariant
                            }
                            size={1.5}
                          />
                        </IconButton>
                      </span>
                      <div className={classes.filterWrapper}>
                        <Collapse
                          in={this.state.menuCollapseOpened}
                          timeout="auto"
                          unmountOnExit
                          style={{ width: "100%" }}
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={4}
                            classes={{ root: classes.gridContainer }}
                            style={{
                              display: this.props.isMobile && "flex",
                              flexDirection: this.props.isMobile && "column",
                            }}
                          >
                            {defaultFilters}
                            {activeFilters}
                          </Grid>
                          <Collapse
                            in={this.state.opened}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Table size="small">
                              <div>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="center"
                                  spacing={4}
                                  classes={{ root: classes.gridContainer }}
                                  style={{
                                    display: this.props.isMobile && "flex",
                                    flexDirection:
                                      this.props.isMobile && "column",
                                  }}
                                >
                                  {inActiveFilters}
                                </Grid>
                              </div>
                            </Table>
                          </Collapse>
                        </Collapse>
                      </div>
                    </div>
                  </>
                }
                secondary={""}
              />
              {!this.props.hideExpand && (
                <IconButton onClick={this.toggleExpand}>
                  {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </ListItem>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterSearchHistory))));
